var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentFolderFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 20H18a1.99 1.99 0 001.188-.387 1.96 1.96 0 00.737-1.038L22.5 10H5.4l-3 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16V6c0-.55.196-1.02.588-1.412A1.924 1.924 0 013 4h6l2 2h8c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412H3.407L3 9.333 1 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentFolderFill);
export default __webpack_public_path__ + "36df09cb2ece0eb35f3960e446aa6109.svg";
export { ForwardRef as ReactComponent };